import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useIsCheckOrder() {
    return useAppSelector((state) => state?.checkOrder.isCheckOrder)
}
